<script setup lang="ts">
import type { ElementalTypeEnum } from '~~/src/types/elemental'
import MenuItem from '@/components/FloatMenu/FloatMenuOption/indev.vue'
import { useRemoveSaveElemental } from '~~/src/composables/mutations/elemetal/useRemoveSaveElemental'
import { useRemoveSaveElementalInAList } from '~~/src/composables/mutations/elemetal/useRemoveSaveElementalInAList'

const { elementalType, id, listId, listType } = defineProps<Props>()

defineOptions({
  name: 'RemoveSaveElementalItem',
})

interface Props {
  id?: string
  elementalType: ElementalTypeEnum
  listId?: string
  listType?: ElementalTypeEnum
}

const { mutate, isPending } = useRemoveSaveElemental()
const { mutate: mutateInAList, isPending: isPendingInAList } = useRemoveSaveElementalInAList()

const handlerChange = async () => {
  if (!id)
    return

  if (listId) {
    mutateInAList({
      id,
      elementalType,
      listId,
    })
    return
  }
  mutate({
    id,
    elementalType,
    listType,
  })
}
</script>

<template>
  <MenuItem :disabled="isPending || isPendingInAList" @select="handlerChange">
    <template #icon>
      <div i-material-symbols:bookmark-outline w-3 h-3 />
    </template>
    {{ listId ? 'Remove from List' : ' Unsave' }}
  </MenuItem>
</template>
